import React from 'react';
import { GuessEntry } from '../types';
import GuessRow from './GuessRow';

interface GameBoardProps {
  guesses: GuessEntry[];
  maxGuesses: number;
  reveal?: boolean;
}

const GameBoard: React.FC<GameBoardProps> = ({ guesses, maxGuesses, reveal = true }) => {
  const rows = Array.from({ length: maxGuesses }).map((_, idx) => guesses[idx]);

  return (
    <div className="game-board">
      {rows.map((guess, idx) => (
        <GuessRow key={`row-${idx}`} guess={guess} rowIndex={idx} reveal={reveal} />
      ))}
    </div>
  );
};

export default GameBoard;
